var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72 6.48L3.6 7.6L7.2 11.2L15.2 3.2L14.08 2.08L7.2 8.92L4.72 6.48V6.48ZM14.4 8C14.39 11.52 11.52 14.36 8 14.35C4.48 14.34 1.64 11.47 1.65 7.95C1.66 4.43 4.53 1.59 8.05 1.6C8.63 1.6 9.2 1.68 9.76 1.84L11 0.6C10.05 0.19 9.03 0 8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8H14.4V8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckColor);
export default __webpack_public_path__ + "static/media/CheckColor.d4223b1fd446bcebb09cece06dc26d32.svg";
export { ForwardRef as ReactComponent };